export const QA_NAME_APPLICANT_PROFILE_HEADER_AVATAR =
  'applicantProfileHeaderAvatar'

export const QA_NAME_APPLICANT_PROFILE_HEADER_NEW_BADGE =
  'applicantProfileHeaderNewBadge'
